import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    info: {
      data: {
        memberRank: {
          name: '会员'
        }
      }
    },
    enterpriseId: 'Enterp_0000000000000000000049090',
    color: '62a8ea',
    imgHost: 'http://img.jihui88.com/',
    hidePanel: []
  },
  getters: {
    info: state => state.info,
    enterpriseId: state => state.enterpriseId,
    color: state => state.color,
    imgHost: state => state.imgHost,
    hidePanel: state => state.hidePanel
  },
  mutations: {
    setInfo (state, info) {
      state.info = info
    },
    setEnterpriseId (state, enterpriseId) {
      state.enterpriseId = enterpriseId
    },
    setColor (state, color) {
      state.color = color
    },
    setHidePanel (state, hidePanel) {
      state.hidePanel = hidePanel
    }
  },
  actions: {}
})

export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js